<template>
  <div class="newfhk">
    <details>
      <summary>演员列表</summary>
      <Category :list="actors" @search="handleSearch"></Category>
    </details>
    <h1>NEWFHK</h1>
    <Info :keyword="keyword || '全部'" :category="category || '全部'" :page="page" :totalPage="totalPage"></Info>
    <Searcher @search="handleSearch" :showCategory="true"></Searcher>
    <Pager :page="page" :totalPage="totalPage" @changePage="handleChangePage"></Pager>
    <Newfhkbody :docs="docs" :imgUrl="imgUrl" :token="token" :username="username"></Newfhkbody>
    <Searcher @search="handleSearch" :showCategory="true"></Searcher>
    <Pager :page="page" :totalPage="totalPage" @changePage="handleChangePage"></Pager>
    <Info :keyword="keyword || '全部'" :category="category || '全部'" :page="page" :totalPage="totalPage"></Info>
  </div>
</template>

<script>
import $ from "jquery/dist/jquery.min.js";
import Info from "./Info";
import Pager from "./Pager";
import Searcher from "./Searcher";
import Category from "./Category";
import Newfhkbody from "./Newfhkbody";
export default {
  name: "Newfhk",
  components: {
    Info,
    Pager,
    Searcher,
    Category,
    Newfhkbody
  },
  props: {
    urlBase: String,
    token: String,
    username: String
  },
  computed: {
    url: function() {
      return this.urlBase + "/newfhk";
    },
    totalPage: function() {
      return Math.ceil(this.count / this.countPerPage);
    },
    actorUrl: function() {
      return this.url + "/actors";
    },
    countUrl: function() {
      return this.url + "/count";
    },
    imgUrl: function() {
      return this.url + "/img/";
    },
    downloadUrl: function() {
      return this.urlBase + "/download";
    }
  },
  data: function() {
    return {
      count: 0,
      keyword: "",
      category:"",
      page: 1,
      countPerPage: 12,
      docs: [],
      actors: []
    };
  },
  created: function() {
    this.getActors();
    this.getCount();
    this.getContent();
  },
  methods: {
    getActors() {
      $.get(this.actorUrl, { token: this.token })
        .then(result => {
          if (result.success) {
            this.actors = result.actors;
          }
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    getCount() {
      $.get(`${this.countUrl}?category=${this.category}&keyword=${this.keyword}`, { token: this.token })
        .then(result => {
          if (result.success) {
            this.count = result.count;
          }
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    getContent() {
      $.get(
        `${this.url}?category=${this.category}&keyword=${this.keyword}&page=${this.page}&countPerPage=${this.countPerPage}`,
        { token: this.token }
      )
        .then(result => {
          if (result.success) {
            this.docs = result.docs;
            if (this.username=='nutbrain') {
              this.docs.forEach((doc,index) => {
                this.getDownload(index)
              });
            }
          }
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    getDownload(index) {
      $.get(`${this.downloadUrl}?number=${this.docs[index].number}`, {
        token: this.token
      }).then(result => {
        let doc = this.docs[index];
        if (result.success) {
          doc.download = true;
        } else {
          doc.download = false;
        }
        this.$set(this.docs, index, doc);
      });
    },
    handleChangePage(p) {
      this.page = p;
      this.getContent();
      window.scrollTo(0, 0);
    },
    handleSearch(filter) {
      this.keyword = filter.keyword||"";
      this.category = filter.category || "";
      this.page = 1;
      this.getCount();
      this.getContent();
      this.hideCategory();
      window.scrollTo(0, 0);
    },
    hideCategory(){
      $('details')[0].open=false
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}
h1{
    text-align: center;
    font-family: cursive;
    text-shadow: #aaa 2px 2px 5px
}
h3 {
  margin: 40px 0 0;
  text-align: center;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
  width: 100%;
}
a {
  color: #42b983;
}
button {
  width: 100%;
}
.card {
  border: solid 1px rgb(141, 141, 141);
  padding: 10px;
}


.newfhk>details>summary{
  text-align: center
}
</style>
